import { render, staticRenderFns } from "./Picture.vue?vue&type=template&id=097d0a75&"
import script from "./Picture.vue?vue&type=script&lang=ts&"
export * from "./Picture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports